import "@fortawesome/fontawesome-free/css/all.min.css";
import Dashboard from "views/Dashboard/Dashboard.js";
import Profile from "views/UserProfile/Profile.js";
import Ticket from "views/UserTicket/Tickets.js";
import CreateTicket from "views/UserTicket/CreateTicket.js";
import ViewTicket from "views/UserTicket/ViewTicket.js";
import MyTickets from "views/UserLottery/MyLotteries.js";
import KenoTickets from "views/UserLottery/KenoTickets.js";
import KenoTicket from "views/UserLottery/KenoTicket.js";
import ViewLottery from "views/UserLottery/ViewLottery.js";
import Transactions from "views/UserTransaction/Transactions.js";
import TruevoStatus from "views/Truevo/status.js";
import SimbalottoStatus from "views/Simbalotto/status.js";
import FineraStatus from "views/Finera/status.js";
import SkrillStatus from "views/Skrill/status.js";
import PaygamesStatus from "views/Paygames/status.js";

var routes = [
  {
    path: "/dashboard",
    name: "menu.dashboard",
    icon: "fas fa-gauge text-primary",
    component: Dashboard,
    layout: "/auth",
  },
  {
    path: "/my-tickets",
    name: "menu.my-tickets",
    icon: "fas fa-ticket text-warning",
    component: MyTickets,
    layout: "/auth",
  },
  {
    path: "/my-ticket/:ticket_id",
    name: "menu.my-tickets",
    icon: "fas fa-ticket text-warning",
    component: ViewLottery,
    layout: "/auth",
    ignore: true,
  },
  // {
  //   path: "/keno-tickets",
  //   name: "menu.keno-tickets",
  //   icon: "fas fa-ticket text-warning",
  //   component: KenoTickets,
  //   layout: "/auth",
  // },
  {
    path: "/keno-ticket/:ticket_id",
    name: "menu.keno-tickets",
    icon: "fas fa-ticket text-warning",
    component: KenoTicket,
    layout: "/auth",
    ignore: true,
  },
  {
    path: "/my-profile",
    name: "menu.my-profile",
    icon: "fas fa-user text-dark",
    component: Profile,
    layout: "/auth",
  },
  {
    path: "/support-tickets",
    name: "menu.tickets",
    icon: "fas fa-list text-red",
    component: Ticket,
    layout: "/auth",
  },
  {
    path: "/support-ticket/new",
    name: "tickets.create-ticket",
    icon: "fas fa-list text-red",
    component: CreateTicket,
    layout: "/auth",
    ignore: true,
  },
  {
    path: "/support-ticket/view/:id",
    name: "tickets.view-ticket",
    icon: "fas fa-list text-red",
    component: ViewTicket,
    layout: "/auth",
    ignore: true,
  },
  {
    path: "/transactions",
    name: "menu.transactions",
    icon: "fas fa-money-bill text-green",
    component: Transactions,
    layout: "/auth",
  },
  {
    path: "/truevo/status",
    name: "menu.transactions",
    icon: "fas fa-money-bill text-green",
    component: TruevoStatus,
    layout: "/auth",
    ignore: true,
  },
  {
    path: "/simbalotto-gw/status",
    name: "menu.transactions",
    icon: "fas fa-money-bill text-green",
    component: SimbalottoStatus,
    layout: "/auth",
    ignore: true,
  },
  {
    path: "/finera/status",
    name: "menu.transactions",
    icon: "fas fa-money-bill text-green",
    component: FineraStatus,
    layout: "/auth",
    ignore: true,
  },
  {
    path: "/skrill/status",
    name: "menu.transactions",
    icon: "fas fa-money-bill text-green",
    component: SkrillStatus,
    layout: "/auth",
    ignore: true,
  },
  {
    path: "/paygames/status",
    name: "menu.transactions",
    icon: "fas fa-money-bill text-green",
    component: PaygamesStatus,
    layout: "/auth",
    ignore: true,
  },
];
export default routes;
